document.addEventListener("DOMContentLoaded", function () {

  const button = document.getElementById("load-more");
  const productList = document.querySelector(".product-list");

  if (!button) return;

  button.addEventListener("click", function () {

    let nextUrl = button.getAttribute("data-next-url");
    button.innerText = "Loading...";

     // window.addEventListener("scroll", () => {
    // if (!button) return;
   // if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 500) {
  //   button.click();
  // }

   //});

    fetch(nextUrl)
      .then(res => res.text())
      .then(data => {

        let html = new DOMParser().parseFromString(data, "text/html");

        let newProducts = html.querySelectorAll(".product-card");
        let newNext = html.querySelector("#load-more");

        newProducts.forEach(product => {
          productList.appendChild(product);
        });

        if (newNext) {
          button.setAttribute("data-next-url", newNext.dataset.nextUrl);
          button.innerText = "Load More";
        } else {
          button.remove();
        }

      });

  });

});